<template>
  <div class="pdf-page">
    <div id='webpdf'></div>
  </div>
</template>

<script>
// 乔商家预览pdf页面页面
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'

export default {
  name: 'webpdf',
  data () {
    return {
      pdfh5: null,
      pdfUrl: ''
    }
  },
  mounted () {
    this.initpdf()
  },
  methods: {
    initpdf () {
      const { typeurl } = this.$route.query
      console.log(typeurl)
      const url = decodeURIComponent(typeurl)
      this.pdfh5 = new Pdfh5('#webpdf', {
        pdfurl: url
      })
      this.pdfh5.on('complete', function (status, msg, time) {
        console.log('状态：' + status + '，信息：' + msg + '，耗时：' + time + '毫秒，总页数：' + this.totalNum)
      })
    }
  }
}
</script>

<style lang='less'>
.pdf-page{
  position: relative;
}
</style>
